// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE
'use strict';

var Block = require("bs-platform/lib/js/block.js");
var Js_dict = require("bs-platform/lib/js/js_dict.js");
var Js_json = require("bs-platform/lib/js/js_json.js");
var Plate$BwaxMobile = require("../../../bwax-js/ml/plate.bs.js");
var Runtime_common$BwaxMobile = require("../../../bwax-js/ml/lang/mod/runtime_common.bs.js");
var Lang_entry_slim$BwaxMobile = require("../../../bwax-js/ml/lang/lang_entry_slim.bs.js");

function pack_page_params(params) {
  return Runtime_common$BwaxMobile.pack_list(Plate$BwaxMobile.List.map((function (param) {
                    return /* tuple */[
                            /* V_tuple */Block.__(0, [/* :: */[
                                  Runtime_common$BwaxMobile.pack_string(param[0]),
                                  /* :: */[
                                    Runtime_common$BwaxMobile.pack_string(param[1]),
                                    /* [] */0
                                  ]
                                ]]),
                            Runtime_common$BwaxMobile.nt
                          ];
                  }), Plate$BwaxMobile.List.keep_map((function (param) {
                        var k = param[0];
                        return Plate$BwaxMobile.$$Option.map((function (s) {
                                      return /* tuple */[
                                              k,
                                              s
                                            ];
                                    }), Js_json.decodeString(param[1]));
                      }), Plate$BwaxMobile.$$Option.with_default(/* [] */0, Plate$BwaxMobile.$$Option.map(Plate$BwaxMobile.List.from_array, Plate$BwaxMobile.$$Option.map(Js_dict.entries, Js_json.decodeObject(params)))))));
}

function need_prepared_data(param) {
  var arity = Lang_entry_slim$BwaxMobile.get_init_arity(/* tuple */[
        param[0],
        param[1]
      ]);
  if (arity !== undefined) {
    return arity >= 2;
  } else {
    return false;
  }
}

function get_string(name, binds) {
  var match = Plate$BwaxMobile.List.assoc(name, binds);
  if (match !== undefined) {
    var match$1 = match[0];
    if (typeof match$1 === "number" || match$1.tag !== /* V_literal */5) {
      return ;
    } else {
      var match$2 = match$1[0];
      if (typeof match$2 === "number" || match$2.tag !== /* String */2) {
        return ;
      } else {
        return match$2[0];
      }
    }
  }
  
}

function get_head(binds) {
  var match = Plate$BwaxMobile.List.assoc("head", binds);
  if (match !== undefined) {
    return ;
  }
  
}

function get_page_def(value) {
  var match = value[0];
  if (typeof match === "number" || match.tag !== /* V_record */2) {
    return ;
  } else {
    var binds = match[0];
    var match$1 = Plate$BwaxMobile.List.assoc("layout", binds);
    if (match$1 !== undefined) {
      var match$2 = match$1[0];
      if (typeof match$2 === "number" || match$2.tag !== /* V_raw */7) {
        return ;
      } else {
        get_head(binds);
        return /* tuple */[
                match$2[0],
                undefined,
                undefined
              ];
      }
    } else {
      return ;
    }
  }
}

exports.pack_page_params = pack_page_params;
exports.need_prepared_data = need_prepared_data;
exports.get_string = get_string;
exports.get_head = get_head;
exports.get_page_def = get_page_def;
/* Plate-BwaxMobile Not a pure module */
